import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";
 

export async function postParticipantExternalSystem(ParticipantExternalVivo: any) {
  try {
    const participantExternalSystemResponse = await axiosInterceptor.post(`${environment.postParticipantExternalSystemConfigURL}`, ParticipantExternalVivo);
    return participantExternalSystemResponse;
  } catch (error: any) {
    return error;
  }
}
export async function updateParticipantExternalSystem(participantId: number, clientId: number,systemName: string, isEnabled:string) {
  try {
    const updateParticipantExternalSystemResponse = await axiosInterceptor.put(`${environment.updateParticipantExternalSystemConfigURL}${participantId}?systemName=${systemName}&clientId=${clientId}&isEnabled=${isEnabled}`);
    return updateParticipantExternalSystemResponse;
  } catch (error: any) {
    return error;
  }
} 

export async function getParticipantExternalSystem(participantId: number, clientId: number, systemName: string) {
  try {
    const getResponse = await axiosInterceptor.get(`${environment.getParticipantExternalSystemConfigURL}${participantId}?clientId=${clientId}&systemName=${systemName}`);
    return getResponse;
  } catch (error: any) {
    return error;
  }
}